import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth:'100%'}}
                                                 src={require('@images/How to prioritise tasks ready for action.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
    isn't it interesting?
    </span></div>
                                            <p>Which one would you go for?</p>
                                            <div className="border_subtitle">The power of choice</div>
                                            <p>We are faced with so many different choices each and every
                                                day. The coffee shop chain Starbucks
                                                has boasted that it offers each customer 19,000 beverage
                                                possibilities at every store. Being able
                                                to choose what needs to happen and when can help to provide
                                                control of a situation. At work we
                                                are faced with many choices and therefore countless
                                                decisions, and having choices can either
                                                help or hinder us. So what are the effects on us of having
                                                too much choice?</p>

                                            <div className="lightgreencontentbg keyquestionpadnew">
                                                <div className="border_subtitle">Which one do I choose?
                                                </div>
                                                <p>In a fascinating study, Kathleen Vohs and her
                                                    colleagues<a className="superscripttext"
                                                                 href="further_info.php?course=300"><sup>1</sup></a> decided
                                                    to research the effect of
                                                    choice on our mental functioning. The researchers asked
                                                    one group of participants to make
                                                    choices on some consumer goods to buy or course options
                                                    to choose. They then asked another
                                                    group to think about the various different options but
                                                    not to make any choices. They then tested
                                                    the participants using a number of measures such as
                                                    mental arithmetic, physical wellbeing and
                                                    recovery from setbacks.</p>
                                                <p>They found that those who were asked to make difficult
                                                    choices that were perceived as
                                                    requiring lots of mental effort reported lower levels of
                                                    self-control. This included less physical
                                                    stamina, reduced persistence in the face of failure,
                                                    more procrastination and worsened mental
                                                    arithmetic. They conducted a further study to test these
                                                    findings and found that amongst a
                                                    large sample of shoppers, the more (complex) decisions
                                                    led to a lesser feeling of self-control,
                                                    adding credence to the first section of the study.</p>
                                                <div className="uiheading"><p>These results suggest that
                                                    self-regulation, active initiative, and effortful
                                                    choosing draw on the
                                                    same psychological resource. Making decisions depletes
                                                    that resource, which weakens our
                                                    subsequent capacity for self-control and active
                                                    initiative.</p>
                                                </div>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}